import styled from 'styled-components';
export default styled.span.withConfig({
  displayName: "Message",
  componentId: "sc-7xjr9u-0"
})(["padding-bottom:2px;padding-top:2px;flex:", ";"], function (props) {
  return props.theme.banner.align === 'center' ? undefined : 1;
});